import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Link } from "react-router"
import { Panel, Glyphicon, Checkbox, FormGroup, FormControl } from 'react-bootstrap'

import { getProducts, getActivities, getCityActivities } from "../selectors"
import RelationList from "./Product.RelationList"
import HoverTip from "../components/HoverTip"

import "./Product.Relations.less"

class Relations extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { }
  }

  render() {
    return (
      <div className="ProductRelations">
        <Panel bsStyle="warning" className="bordered-panel">
          <Panel.Heading>
            <Panel.Title>Relaciones</Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            <FormGroup>
              <Checkbox
                checked={this.props.relations.isShy}
                onChange={evt => {
                  this.props.onChange({
                    ...this.props.relations,
                    isShy: evt.target.checked
                  })
                }}
              >
                Oculto 
                <HoverTip text="El producto no aparecerá en la lista, pero podrá ser accesible desde otros enlaces.">
                  <Glyphicon glyph="question-sign" />
                </HoverTip>
              </Checkbox>
            </FormGroup>

            <h4>Tipos de entrada incluidos:</h4>

            <RelationList
              products={this.props.products}
              list={this.props.relations.includes}
              onChange={newList => this.props.onChange({ 
                ...this.props.relations, 
                includes: newList 
              })}
              product={this.props.product}
            />

            <h4>Este pack contiene ...</h4>

            <RelationList
              products={this.props.products}
              list={this.props.relations.packOf}
              onChange={newList => this.props.onChange({ 
                ...this.props.relations, 
                packOf: newList 
              })}
              product={this.props.product}
            />
            
            <h4>Actividad relacionada:</h4>
            
            <FormGroup className="relatedActivityFg">
              <FormControl
                className="relatedActivitySelect"
                componentClass="select"
                value={this.props.product.relations.activity || "_NULL_"}
                onChange={evt => {
                  const v = evt.target.value
                  this.props.onChange({ 
                    ...this.props.relations, 
                    activity: v == "_NULL_" ? null : v
                  })
                }}
              >
                <option value="_NULL_">Ninguna</option>
                <option disabled>------------------</option>
                {
                  this.props.thisCityActivities.map(a => (
                    <option key={a._id} value={a._id}>{a.name || "[Sin nombre]"} ({a.title || a._id})</option>
                  ))
                }
              </FormControl>
              {
                this.props.product.relations.activity && (
                  <Link to={`/private/activity/${encodeURIComponent(this.props.product.relations.activity)}`}>
                    Ver
                  </Link>
                )
              }
            </FormGroup>
            
          </Panel.Body>
        </Panel>
      </div>
    )
  }
}

Relations.propTypes = {
  products: PropTypes.objectOf(PropTypes.object).isRequired,
  product : PropTypes.object.isRequired,
  relations: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  thisCityActivities: PropTypes.arrayOf(PropTypes.object).isRequired,
}

const mapStateToProps = (state, ownProps) => ({
  products: getProducts(state, ownProps),
  Activities: getActivities(state, ownProps),
  thisCityActivities: getCityActivities(state, ownProps.product.city),
})

export default connect(mapStateToProps)(Relations)
